// extracted by mini-css-extract-plugin
module.exports = {"root":"StatsSharing_root__3Jq2K","preview-content":"StatsSharing_preview-content__1HCqJ"};